const state = {
  items: [],
  actives: []
}

export default state
